import axios from 'axios';
import { getHostname } from './server/server' 

const hostname = getHostname();
const userObjectRestrictionPath = '/v2/userObjectRestriction';

async function getUserObjectRestriction(restrictionId) {
    const res = await axios.get(`${hostname}${userObjectRestrictionPath}?restrictionId=${restrictionId}`);
    return res.data;
}

async function getUserObjectRestrictionsByCustomer(customerId) {
    const res = await axios.get(`${hostname}${userObjectRestrictionPath}/customer?customerId=${customerId}`);
    return res.data;
}

async function getUserObjectRestrictionsByUser(customerId, userId) {
    const res = await axios.get(`${hostname}${userObjectRestrictionPath}/user?customerId=${customerId}&userId=${userId}`);
    return res.data;
}

async function getUserObjectRestrictionsByObject(customerId, objectType, objectId) {
    const res = await axios.get(`${hostname}${userObjectRestrictionPath}/object?customerId=${customerId}&objectType=${objectType}&objectId=${objectId}`);
    return res.data;
}

async function addUserObjectRestriction(restriction) {
    const res = await axios.post(`${hostname}${userObjectRestrictionPath}`, restriction);
    return res.data;
}

async function updateUserObjectRestriction(restriction) {
    const res = await axios.put(`${hostname}${userObjectRestrictionPath}`, restriction);
    return res.data;
}

async function deleteUserObjectRestriction(restrictionId) {
    const res = await axios.delete(`${hostname}${userObjectRestrictionPath}?restrictionId=${restrictionId}`);
    return res.data;
}

export {
    getUserObjectRestriction,
    getUserObjectRestrictionsByCustomer,
    getUserObjectRestrictionsByUser,
    getUserObjectRestrictionsByObject,
    addUserObjectRestriction,
    updateUserObjectRestriction,
    deleteUserObjectRestriction
}